import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { SourceEntity } from 'types/SourceEntity'
import { isMFNLink } from './utils'
import { EditSourceDialog } from './AdminEditSourceDialog'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Stack from '@mui/material/Stack'
import { formatDateYYYYMMDDhhmm } from '../../../../packages/utils/numberFormatters'
import Button from '@mui/material/Button'
import { SourceUrl } from './AdminSourceUrl'
import { IssueEntity } from 'types/IssueEntity'
import { WarrantEntity } from 'types/WarrantEntity'
import { ConvertibleEntity } from 'types/ConvertibleEntity'

function SourceTitleOrScrapeButton({ source }: { source: SourceEntity }) {
    if (source.title) {
        return <Typography>{source.title}</Typography>
    }

    if (!isMFNLink(source.sourceUrl)) {
        return <Typography>Ingen MFN-länk</Typography>
    }

    return <Typography>Titel saknas!</Typography>
}

export function SourceTableRow({
    source,
    sources,
    setSources,
    duplicateSources = {},
    issue,
    warrant,
    convertible,
}: {
    source: SourceEntity
    sources: SourceEntity[]
    setSources: (sources: Array<SourceEntity>) => void
    duplicateSources: Record<string, boolean>
    issue?: IssueEntity
    warrant?: WarrantEntity
    convertible?: ConvertibleEntity
}) {
    const [openEditDialog, setOpenEditDialog] = useState(false)
    const handleDelete = (source: SourceEntity) => {
        setSources(
            sources.filter((s) => {
                if (source.id) return s.id !== source.id

                return source.sourceUrl !== s.sourceUrl
            }),
        )
    }
    return (
        <React.Fragment>
            {createPortal(
                <EditSourceDialog
                    open={openEditDialog}
                    setOpen={setOpenEditDialog}
                    source={source}
                    sources={sources}
                    setSources={setSources}
                    issue={issue}
                    warrant={warrant}
                    convertible={convertible}
                />,
                document.body,
            )}
            <TableRow key={source.sourceUrl}>
                <TableCell>
                    <Stack>
                        <SourceUrl url={source.sourceUrl} />
                        {duplicateSources[source.sourceUrl] && (
                            <Typography variant='caption' sx={{ color: 'red' }}>
                                Registrerad tidigare
                            </Typography>
                        )}
                    </Stack>
                </TableCell>
                <TableCell>{source.internalComment}</TableCell>
                <TableCell>{source.sourceType}</TableCell>
                <TableCell>
                    <SourceTitleOrScrapeButton source={source} />
                </TableCell>
                <TableCell>{formatDateYYYYMMDDhhmm(source.publishedDate)}</TableCell>
                <TableCell>
                    <Stack spacing={1}>
                        <Button variant='outlined' onClick={() => setOpenEditDialog(true)}>
                            Redigera
                        </Button>
                        <Button variant='text' onClick={() => handleDelete(source)}>
                            [Ta&nbsp;bort]
                        </Button>
                    </Stack>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}
